<template>
  <v-container>
    <v-row>
      <v-col>
        <v-menu bottom right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
              <span>{{ typeCalendar[calendarSelected] }}</span>
              <v-icon right>
                mdi-menu-down
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="changeType('validity')">
              <v-list-item-title>{{typeCalendar.validity}}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="changeType('installDate')">
              <v-list-item-title>{{typeCalendar.installDate}}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="changeType('withdrawn')">
              <v-list-item-title>{{typeCalendar.withdrawn}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-sheet>
          <v-toolbar flat>
            <v-btn fab text small color="grey darken-2" @click="prev">
              <v-icon small>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="next">
              <v-icon small>
                mdi-chevron-right
              </v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right>
                    mdi-menu-down
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>Dia</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>Semana</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>Mês</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-sheet>
        <v-sheet>
          <v-calendar
            locale="pt-br"
            ref="calendar"
            v-model="focus"
            color="primary"
            :events="events"
            :event-color="getEventColor"
            :type="type"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @change="updateRange"
          ></v-calendar>
          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            offset-x
          >
            <v-card color="grey lighten-4">
              <v-toolbar @click="cardPressed(selectedEvent.orderId)" :color="selectedEvent.color" dark>
                <v-row>
                  <h2>{{selectedEvent.nameEdited}}</h2>
                </v-row>
              </v-toolbar>
              <v-card-text v-if="selectedEvent.obs != null && selectedEvent.obs != ''">
                <span v-html="selectedEvent.obs"></span>
              </v-card-text>
              <v-card-actions v-if="calendarSelected == 'withdrawn'">
                <v-btn color="green" style="color:white" @click="sendEmail(selectedEvent)">
                  Enviar Email de Confirmação
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialog.show"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          {{dialog.title}}
        </v-card-title>

        <v-card-text>
          {{dialog.message}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialog.show = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import CrudService from '../../../services/CrudService';

export default {
  data: () => ({
    focus: "",
    type: "month",
    calendarSelected: "withdrawn",
    typeCalendar: {
      validity: "",
      installDate: "",
      withdrawn: "",
    },
    typeToLabel: {
      month: "Mês",
      week: "Semana",
      day: "Dia",
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    beginDate: "",
    endDate: "",
    loginData: null,
    dialog: {
      show: false,
      title: '',
      message: ''
    },
  }),
  mounted() {
    this.$refs.calendar.checkChange();
  },
  methods: {
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => {
          this.selectedOpen = true;
        }, 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    cardPressed(orderId){
      localStorage.setItem("orderId", orderId);
      this.$router.push('addUpdateOrder');
    },
    async sendEmail(obj){
      let loader = this.$loading.show();

      try
      {
        let crudService = new CrudService();

        let objLabel = this.loginData.labels.find(label => {
          return label.typeLabel == 17
        });

        let request = {
          signatureId: this.loginData.userData.signatureId,
          codeId: obj.code,
          label: objLabel != null && objLabel.name != null ? objLabel.name : "Pedidos",
          calendarName: this.typeCalendar.withdrawn
        };

        let result = await crudService.post(`calendar`, request, this.loginData.token);

        if(result.status == 200){
          this.dialog.title = "Sucesso";
          this.dialog.message = "Email enviado com sucesso.";
          this.dialog.show = true;
        }
        else if(result.status == 401){
          localStorage.removeItem("loginData");
          this.$router.push({name: 'Login', params: {logout: true}});
        }
        else if(result.status == 400){
          this.dialog.title = "Erro";
          this.dialog.message = result.data[0];
          this.dialog.show = true;
        }
        else if(result.status != 204){
          this.dialog.title = "Erro";
          this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
          this.dialog.show = true;
        }
        
        loader.hide();
      }
      catch
      {
        loader.hide();
        this.dialog.title = "Erro";
        this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
        this.dialog.show = true;
      }

      this.selectedOpen = false
    },
    async getData(){
      let loader = this.$loading.show();

      try
      {
        let crudService = new CrudService();

        let result = await crudService.get(`calendar?SignatureId=${this.loginData.userData.signatureId}&BeginDate=${this.beginDate}&EndDate=${this.endDate}&Type=${this.calendarSelected}&PersonId=${this.loginData.userData.personId}`, this.loginData.token);

        if(result.status == 200){
          const events = [];
          let chromeAgent = navigator.userAgent.indexOf("Chrome") > -1; 
          let safariAgent = navigator.userAgent.indexOf("Safari") > -1; 

          let objLabel = this.loginData.labels.find(label => {
            return label.typeLabel == 17
          });

          if (chromeAgent && safariAgent){
            result.data.forEach(r => {
              events.push({
                name: `${r.name} - ${r.code}`,
                nameEdited: `${objLabel != null && objLabel.name != null ? objLabel.name : "Pedido"} nº ${r.code}`,
                start: new Date(`${r.date.split('T')[0]} ${r.time != null ? r.time : "00:00:00"}`),
                end: "",
                color: r.color != null ? r.color : "primary",
                timed: r.time != null,
                code: r.code,
                orderId: r.orderId,
                obs: `<b>Cliente:</b> ${r.name != null ? r.name : ""} <br><b>Setor:</b> ${r.statusName != null ? r.statusName : ""} <br><b>Obs:</b> ${r.obs != null ? r.obs : ""} <br><br><b>E-mail:</b> ${r.email != null ? r.email : ""}`
              });
            })
          }
          else{
            result.data.forEach(r => {
              events.push({
                name: `${r.name} - ${r.code}`,
                nameEdited: `${objLabel != null && objLabel.name != null ? objLabel.name : "Pedido"} nº ${r.code}`,
                start: new Date(`${r.date.split('T')[0]}T${r.time != null ? r.time : "00:00"}:00.000-03:00`),
                end: "",
                color: r.color != null ? r.color : "primary",
                timed: r.time != null,
                code: r.code,
                orderId: r.orderId,
                obs: `<b>Cliente:</b> ${r.name != null ? r.name : ""} <br><b>Setor:</b> ${r.statusName != null ? r.statusName : ""} <br><b>Obs:</b> ${r.obs != null ? r.obs : ""} <br><br><b>E-mail:</b> ${r.email != null ? r.email : ""}`
              });
            })
          }

          this.events = events;
        }
        else if(result.status == 401){
          localStorage.removeItem("loginData");
          this.$router.push({name: 'Login', params: {logout: true}});
        }
        else if(result.status == 400){
          this.dialog.title = "Erro";
          this.dialog.message = result.data[0];
          this.dialog.show = true;
        }
        else if(result.status != 204){
          this.dialog.title = "Erro";
          this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
          this.dialog.show = true;
        }
        
        loader.hide();
      }
      catch
      {
        loader.hide();
        this.dialog.title = "Erro";
        this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
        this.dialog.show = true;
      }
    },
    async changeType(type){
      this.calendarSelected = type;
      await this.getData();
    },
    async updateRange({ start, end }) {
      this.beginDate = `${start.date} 00:00:00`;
      this.endDate = `${end.date} 23:59:59`;

      await this.getData();
    },
  },
  async created(){
    this.loginData = JSON.parse(localStorage.getItem("loginData"));

    this.typeCalendar.validity = "Entregas";
    this.typeCalendar.installDate = "Instalações";
    this.typeCalendar.withdrawn = "Retiradas";

    let validity = this.loginData.labels.find(label => {
      return label.typeLabel == 3
    });

    let installDate = this.loginData.labels.find(label => {
      return label.typeLabel == 2
    });

    let withdrawn = this.loginData.labels.find(label => {
      return label.typeLabel == 23
    });

    if(validity != null && validity.name != null)
      this.typeCalendar.validity = validity.name;

    if(installDate != null && installDate.name != null)
      this.typeCalendar.installDate = installDate.name;

    if(withdrawn != null && withdrawn.name != null)
      this.typeCalendar.withdrawn = withdrawn.name;
  }
};
</script>
<style>
.v-calendar-daily__pane{
  height: 1190px !important; 
}
</style>